module.exports = __webpack_public_path__ + "media/chicken-road-ambient.e83dfb90.mp3";